import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store'
import {Tab, Tabs} from 'vant'; 
import "vant/lib/index.css";

const app = createApp(App)
app.use(Tab).use(Tabs)

// import VConsole from 'vconsole';
// if (process.env.NODE_ENV !== 'development') {
//   new VConsole();
// }

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || ''
  next()
})

app.use(router).mount('#app')
